import Navigation from '../../../components/layout/Navigation';
import Footer from '../../../components/layout/Footer';
import Hero from '../../../components/ui/Hero';
import Section from '../../../components/ui/Section';
import FeatureGrid from '../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../components/ui/ProcessTimeline';
import CTA from '../../../components/ui/CTA';

export default function AIPPCPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Precision Advertising.<br /><span className="bg-gradient-to-r from-blue-400 to-orange-500 bg-clip-text text-transparent">Powerful Returns.</span></>}
        description="We craft and continuously optimize Pay-Per-Click campaigns that drive targeted traffic and convert clicks into customers."
        bgImage="/assets/modern-digital-marketing.png"
        primaryBtn={{ text: "Get Strategy", link: "/contact", icon: "ri-rocket-line" }}
        secondaryBtn={{ text: "Success Stories", link: "/work", icon: "ri-play-circle-line" }}
      />

      <Section>
        <FeatureGrid 
          title={<>Beyond Clicks: <span className="bg-gradient-to-r from-blue-600 to-orange-600 bg-clip-text text-transparent">Driving Conversions</span></>}
          subtitle="Optimized PPC campaigns go beyond bidding. We analyze performance data, refine targeting, and improve ad copy."
          items={[
            { title: 'Targeted Research', description: 'Identifying relevant keywords.', icon: 'ri-search-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Compelling Ad Copy', description: 'Crafting engaging ads that drive leads.', icon: 'ri-edit-line', color: 'from-cyan-500 to-teal-500' },
            { title: 'Strategic Bidding', description: 'Maximizing visibility & minimizing costs.', icon: 'ri-auction-line', color: 'from-teal-500 to-green-500' },
            { title: 'Landing Page Opt.', description: 'Ensuring relevance & conversion.', icon: 'ri-pages-line', color: 'from-green-500 to-yellow-500' },
            { title: 'Performance Analysis', description: 'Monitoring metrics for improvement.', icon: 'ri-line-chart-line', color: 'from-yellow-500 to-orange-500' }
          ]}
        />
      </Section>

      <Section className="bg-gray-900">
        <ProcessTimeline 
          title="The PPC Optimization Loop"
          subtitle="Our data-driven process combines human expertise with AI tools to ensure your campaigns perform at peak efficiency."
          steps={[
            { title: 'Discovery', description: 'Defining objectives & budget.', icon: 'ri-compass-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Research', description: 'Keyword & audience identification.', icon: 'ri-search-2-line', color: 'from-cyan-500 to-teal-500' },
            { title: 'Development', description: 'Creating copy & creative.', icon: 'ri-edit-2-line', color: 'from-teal-500 to-green-500' },
            { title: 'Launch', description: 'Setup, targeting, & tracking.', icon: 'ri-rocket-line', color: 'from-green-500 to-yellow-500' },
            { title: 'Optimization', description: 'Analyzing & adjusting.', icon: 'ri-line-chart-line', color: 'from-yellow-500 to-orange-500' }
          ]}
        />
      </Section>

      <CTA 
        title={<>Ready to Convert Clicks <span className="bg-gradient-to-r from-blue-400 to-orange-500 bg-clip-text text-transparent">into Customers?</span></>}
        description="Partner with Hash Adz to build highly effective PPC campaigns that deliver measurable results."
        primaryBtn={{ text: "Start Campaign", link: "/contact" }}
        secondaryBtn={{ text: "View Results", link: "/work" }}
        stats={[
          { number: '500+', label: 'Campaigns' },
          { number: '98%', label: 'Satisfaction' },
          { number: '75+', label: 'Industries' }
        ]}
      />

      <Footer />
    </div>
  );
}